import { createAction, handleActions } from 'redux-actions';
import { Api } from "../../api/api";
import {
    fetchSubmitForm,
    fetchSubmitFormFailed,
    fetchSubmitFormSuccess,
} from '../common/submitForm';
import { hideModal } from '../common/activeModal';
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';

//- Actions
export const fetchGetDepartmentsFailed = createAction('FETCH_GET_DEPARTMENTS_FAILED');
export const fetchGetDepartmentsSuccess = createAction('FETCH_GET_DEPARTMENTS_SUCCESS');
export const onGetDepartmentsSuccess = (data) => (dispatch) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        dispatch(fetchGetDepartmentsSuccess(data));
    } else {
        dispatch(fetchGetDepartments(currentPage - 1));
    }
};
export const fetchGetDepartments = createAction(
    'FETCH_GET_DEPARTMENTS',
    (page) => Api.getDepartments(page),
    () => ({
        apiCall: true,
        onSuccess: onGetDepartmentsSuccess,
        onFail: fetchGetDepartmentsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onGetDepartmentsForCurrentPage = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForDepartments(getState());
    dispatch(fetchGetDepartments(currentPage));
};

export const fetchRegisterDepartment = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRegisterDepartment(data));
};
export const onRegisterDepartment = createAction(
    'FETCH_REGISTER_DEPARTMENT',
    (data) => Api.registerDepartment(data),
    () => ({
        apiCall: true,
        onSuccess: onChangeDepartmentSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onChangeDepartmentSuccess = () => (dispatch) => {
    dispatch(hideModal());
    dispatch(fetchSubmitFormSuccess());
    dispatch(onGetDepartmentsForCurrentPage());
};


export const fetchRemoveDepartment = (departmentId) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRemoveDepartment(departmentId));
};

export const onRemoveDepartment = createAction(
    'FETCH_REMOVE_DEPARTMENT',
    (departmentId) => Api.removeDepartment(departmentId),
    () => ({
        apiCall: true,
        onSuccess: onChangeDepartmentSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    fetching: false,
    data: null,
    error: null,
    currentPage: null,
    totalPages: null
};

//- Reducers
export default handleActions({
    FETCH_GET_DEPARTMENTS: (state) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: null, fetching: true };
    },
    FETCH_GET_DEPARTMENTS_FAILED: (state, action) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false };
    },
    FETCH_GET_DEPARTMENTS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload.content, currentPage: action.payload.number, totalPages: action.payload.totalPages, error: null, fetching: false };
    }
}, initialState);

//- Selectors
export const getDepartments = state => state.departments;

export const loadingDepartments = state => getDepartments(state).fetching;

export const getCurrentPageForDepartments = state => getDepartments(state).currentPage;

export const getTotalPagesForDepartments = state => getDepartments(state).totalPages;

export const getDepartmentsData = state => {
    if (_.isNil(getDepartments(state).data)) {
        return null;
    }

    return _.map(getDepartments(state).data, department => ({
        id: department.id,
        name: department.name,
        email: department.email,
        hrManagerCount: department.hrManagerCount,
        businessOwnerCount: department.businessOwnerCount
    })
    )
};


// WEBPACK FOOTER //
// ./src/reducers/organization/departments.js